import axios from 'axios';


export default {
  // Collections
  createClient (data) {
    return axios.post(`/clients`, data)
      .then(response => response.data);
  },
  getClients () {
    return axios.get(`/clients`)
      .then(response => response.data);
  },
  getClient (id) {
    return axios.get(`/clients/${id}`)
      .then(response => response.data);
  },
  getClientWines (id) {
    return axios.get(`/clients/${id}/wines`)
      .then(response => response.data);
  },
  putClientWines (id, data) {
    return axios.put(`/clients/${id}/wines`, data)
      .then(response => response.data);
  },

  // Item
  updateClient (data) {
    return axios.put(`/clients/${data.client_id}`, data)
      .then(response => response.data);
  },
  deleteClient (id) {
    return axios.delete(`/clients/${id}`)
      .then();
  }
};
